import { makeVar } from '@apollo/client';

interface UserUpdated {
  _id: string | undefined;
  names: string;
  lastNameP: string;
  lastNameM: string;
  email: string;
  rfc: string;
  phone: string;
  curp: string;
}

export const userUpdatedVar = makeVar<UserUpdated | null>(null);

interface UserAndRolesReactiveVars {
  userUpdatedVar: {
    read: () => UserUpdated | null;
  };
}

export const userAndRolesReactiveVars: UserAndRolesReactiveVars = {
  userUpdatedVar: {
    read: () => userUpdatedVar(),
  },
};
